$(window).on 'load', ->
  selectedAddress = window.location.search.replace('?', '#')

  if ($(selectedAddress).length)
    $('html, body').animate { scrollTop: $(selectedAddress).offset().top }, 1000

  $('.main-menu__section').click (event) ->
    selectedAddress = $(this).attr('href').split('?')[1]

    if (selectedAddress)
      selectedAddress = '#'+selectedAddress
      event.preventDefault()
      $('html, body').animate { scrollTop: $(selectedAddress).offset().top }, 1000



// WEBPACK FOOTER //
// ./assets/javascripts/pages/contacts.coffee